import gql from 'graphql-tag';

export const GET_UNREAD = gql`
  query getUnreadNotifications($userId: Int) {
    notifications(
      where: { read: { _neq: true }, recipient_id: { _eq: $userId } }
      order_by: [{ created_at: desc }]
      limit: 20
    ) {
      id
      message
      data
      created_at
      topic
      actor_id
      subject
      subject_id
    }
    unread_aggregate: notifications_aggregate(
      where: { read: { _neq: true }, recipient_id: { _eq: $userId } }
    ) {
      aggregate {
        count
      }
    }
  }
`;
export const GET_NOTIFICATIONS = gql`
  query getNotifications($userId: Int, $limit: Int, $offset: Int) {
    notifications(
      where: { recipient_id: { _eq: $userId } }
      order_by: [{ created_at: desc }]
      limit: $limit
      offset: $offset
    ) {
      id
      message
      data
      created_at
      topic
      actor_id
      subject
      subject_id
    }
    count_aggregate: notifications_aggregate(
      where: { recipient_id: { _eq: $userId } }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const MARK_ALL_READ = gql`
  mutation markread($userId: Int) {
    update_notifications(
      where: { recipient_id: { _eq: $userId } }
      _set: { read: true }
    ) {
      returning {
        id
      }
    }
  }
`;

export const MARK_READ = gql`
  mutation markread($id: Int) {
    update_notifications(where: { id: { _eq: $id } }, _set: { read: true }) {
      returning {
        id
      }
    }
  }
`;

export const INSERT_NOTIFICATION = gql`
  mutation insertNotification($data: [notifications_insert_input!]!) {
    insert_notifications(objects: $data) {
      affected_rows
    }
  }
`;

export const GET_NOTIFICATIONS_SETTINGS = gql`
  query getNotifSettings($userId: Int!) {
    settings: notifications_settings(where: { user_id: { _eq: $userId } }) {
      id
      topic
      email
      sms
      user_id
    }
  }
`;

export const UPDATE_NOTIFICATIONS_SETTINGS = gql`
  mutation updateNotifSetting($data: [notifications_settings_insert_input!]!) {
    insert_notifications_settings(
      objects: $data
      on_conflict: {
        constraint: notifications_settings_user_id_topic_key
        update_columns: [email,sms]
      }
    ) {
      affected_rows
    }
  }
`;
